import ajax from '../ajax'


//参考图标签
export function getIcoMeLabelApi(params) {
    return ajax({
        method:'get',
        url: '/v2/tag/index',
        params
    })
}

//参考图模型标签
export function ModeIcoMeLabelApi(params) {
    return ajax({
        method:'get',
        url: '/v2/tag/model',
        params
    })
}

//参考图模型标签
export function PsIcoMeLabelApi(params) {
    return ajax({
        method:'get',
        url: '/v2/tag/ps',
        params
    })
}


//模型收入
export function AdminIcoMeLabelApi(params) {
    return ajax({
        method:'get',
        url: '/v2/admin/income',
        params
    })
}


//搜索记录
export function SearchIcoMeLabelApi(params) {
    return ajax({
        method:'get',
        url: '/v2/admin/search',
        params
    })
}







//搜索记录dang3d
export function Search1IcoMeLabelApi(params) {
    return ajax({
        method:'get',
        url: '/v2/admin/search1',
        params
    })
}
export function AdminIcoMeLabel_1Api(params) {
    return ajax({
        method:'get',
        url: '/v2/admin/income1',
        params
    })
}




// 列表修改
export function editListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/edit',
        data
    })
}






// WEBPACK FOOTER //
// ./src/apis/income/index.js